import React from "react";

import styles from "./fabList.module.scss";

const FabList = ({ children }) => {
	return <div className={styles.fabList}>{children}</div>;
};

export default FabList;
